module.exports = __webpack_public_path__ + "media/images/icons/instagram-f7679f7d05b9139efb332e18260e03ea.svg";